import requestAction from '../../utils/requestAction'

export const fetchProductBrand = (productBrandId: string) =>
  requestAction('PRODUCTBRAND_DETAIL')(`productBrands/${productBrandId}`, 'GET')
